import { render, staticRenderFns } from "./AddOtherRecipients.vue?vue&type=template&id=4f596aba&scoped=true"
import script from "./AddOtherRecipients.vue?vue&type=script&lang=js"
export * from "./AddOtherRecipients.vue?vue&type=script&lang=js"
import style0 from "./AddOtherRecipients.vue?vue&type=style&index=0&id=4f596aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f596aba",
  null
  
)

export default component.exports